import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable no-case-declarations */

/* eslint-disable prefer-destructuring */

/* eslint-disable consistent-return */
import React, { createContext, useReducer, useMemo, useEffect } from 'react';
import { SET_REPORTS_LIST_GLOBAL } from './constants';

const initFunc = props => null;

const initialState = {
  reportsListGlobal: null,
  dispatch: null
};
const initReportsGlobalContext = {
  reportsListGlobal: null,
  dispatch: null
};
export const ReportsGlobalContextReducer = (state, action) => {
  let newState = _objectSpread({}, state);

  switch (action.type) {
    case SET_REPORTS_LIST_GLOBAL:
      newState.reportsListGlobal = action.payload;
      break;

    default:
      newState = state;
      break;
  }

  return newState;
};
export const ReportsGlobalContext = /*#__PURE__*/createContext(initReportsGlobalContext);
export const ReportsGlobalDispatchContext = /*#__PURE__*/createContext({});
export const ReportsGlobalContextConsumer = ReportsGlobalContext.Consumer;
export const ReportsGlobalDispatchContextConsumer = ReportsGlobalDispatchContext.Consumer;
export const ReportsGlobalContextProvider = ({
  reporting,
  agency,
  children
}) => {
  const [{
    reportsListGlobal
  }, dispatch] = useReducer(ReportsGlobalContextReducer, initialState);

  const getReportList = async () => {
    const response = await reporting.getReports(agency);

    if (!(response instanceof Response)) {
      dispatch({
        type: SET_REPORTS_LIST_GLOBAL,
        payload: response
      });
    }
  };

  useEffect(() => {
    getReportList();
  }, []);
  const context = useMemo(() => ({
    reportsListGlobal,
    dispatch
  }), [reportsListGlobal, dispatch]);
  return /*#__PURE__*/React.createElement(ReportsGlobalContext.Provider, {
    value: context
  }, children);
};
export function withReportsGlobalContext(Component) {
  return function contextComponent(props) {
    return /*#__PURE__*/React.createElement(ReportsGlobalContextConsumer, null, context => /*#__PURE__*/React.createElement(ReportsGlobalDispatchContextConsumer, null, dispatchContext => /*#__PURE__*/React.createElement(Component, _extends({}, props, context, dispatchContext))));
  };
}
export default ReportsGlobalContext;